<template>
  <div class="ksm-personen__page--wrapper">
    <SplitLayout :cols="2" :sidebar_right_width="'width:40%;'">
      <div slot="main-content" class="ksm-texte__modus-main" style="padding:50px 10px">
        <div class="ksm-flex-1 ksm-flex-x-center">
          <div class="ksm-sidebar__container" style="max-width:600px">
            <div
              class="ksm-accordion__header"
              style="border-top-color: transparent;border-bottom:2px solid rgb(162, 173, 186)"
            >
              <div
                class="ksm-flex-1 ksm-flex"
                style="align-items: center; margin-left: 10px;"
              >Biographie</div>
            </div>
            <div v-html="personenText" style="padding:10px"></div>
          </div>
        </div>
      </div>
      <div slot="sidebar-2" class="ksm-flex-1" style="position:relative">
        <div v-if="personenCollection2" class="ksm-sidebar__wrapper">
          <div class="ksm-sidebar__container">
            <div
              class="ksm-accordion__header"
              style="border-top-color: transparent;border-bottom:2px solid rgb(162, 173, 186)"
            >
              <div
                class="ksm-flex-1 ksm-flex"
                style="align-items: center; margin-left: 10px;"
              >Personen</div>
            </div>
            <div class="ksm-personen__list-container" ref="scrollElement">
              <div class="ksm-accordion__content">
                <div v-for="(p,i) of personenCollection2" :key="'p'+i" :id="'pers_'+p.lemmaID">
                  <div
                    class="ksm-personen__title ksm-flex-y-center"
                    :class="selectedIdx===i?'__active':''"
                    style="cursor:pointer"
                  >
                    <div class="ksm-personen__content" @click="selectedIdx=i">{{p.content}}</div>
                    <div
                      v-if="p.text"
                      @click="selectedIdx=i"
                      class="ksm-personen__has"
                      v-html="$_getSvg('id-card.svg')"
                    ></div>
                    <div>&nbsp;({{p.docIds.length}})</div>
                    <div
                      style="height:20px;width:20px"
                      @click="togglePersonItem(p.lemmaID)"
                      v-html="$_getIcon(personenExpandIdx.indexOf(p.lemmaID)>-1?'arrow-down.svg':'arrow-right.svg')"
                    ></div>
                  </div>
                  <div
                    class="ksm-accordion__body"
                    :class="personenExpandIdx.indexOf(p.lemmaID)>-1?'':'ksm-accordion__collapse'"
                    style="background-color:transparent; border-width:0; padding:0 10px"
                  >
                    <g-person-merz style="font-size:10pt; padding-left:15px;" :person="p"></g-person-merz>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SplitLayout>
  </div>
</template>

<script>
import SplitLayout from "comps/SplitLayout.vue";
import SidebarView from "./orte/Sidebar.OrteUndWege";
import KeepScroll from "comps/mixins/KeepScroll";

export default {
  name: "personen",
  mixins: [KeepScroll],
  data() {
    return {
      selectedIdx: 0,
      personenExpandIdx: [],
      firstScroll: false
    };
  },
  components: {
    SplitLayout,
    SidebarView
  },
  watch: {
    schwitters(d) {
      const vue = this;
      if (d && !vue.firstScroll) {
        setTimeout(function() {
          vue.scrollTo(d.lemmaID);
        }, 1);
      }
    }
  },

  activated: function() {
    this.autoScrollToPerson();
  },

  mounted: function() {
    this.autoScrollToPerson();
  },

  methods: {
    autoScrollToPerson() {
      const vue = this;
      if (this.lemmaID) {
        setTimeout(function() {
          vue.scrollTo(vue.lemmaID);
          vue.$router.push({
            query: null
          });
        }, 1);
      } else if (
        this.schwitters &&
        !this.firstScroll &&
        this.personenExpandIdx.length < 2
      ) {
        setTimeout(function() {
          vue.scrollTo(vue.schwitters.lemmaID);
        }, 1);
      }
    },

    togglePersonItem(i, b) {
      const idx = this.personenExpandIdx.indexOf(i);
      if (idx > -1) {
        if (!b) {
          this.personenExpandIdx.splice(idx, 1);
        }
      } else {
        this.personenExpandIdx.push(i);
      }
    },

    async scrollTo(persId) {
      const vue = this;
      const elem = this.$el.querySelector("#pers_" + persId);
      if (elem) {
        elem.scrollIntoView({ block: "start", behavior: "smooth" });
        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false
        });
        const person = this.personenCollection2.find(
          p => p.lemmaID - persId === 0
        );
        this.selectedIdx = this.personenCollection2.indexOf(person);
        this.togglePersonItem(persId, true);
      } else if (persId) {
        setTimeout(function() {
          vue.scrollTo(persId);
        }, 1000);
      }
    }
  },
  computed: {
    lemmaID() {
      return this.$route.query.lemmaID;
    },
    schwitters() {
      if (!this.personenCollection2) {
        return;
      }
      const schwitters = this.personenCollection2.find(
        // p => p.content === "Schwitters, Kurt"
        p => p.content === "Doesburg, Nelly »Pétro« van"
      );
      return schwitters;
    },
    personenCollection2() {
      return this.$store.state.personen.collection2;
    },

    personenText() {
      if (!this.personenCollection2) {
        return;
      }
      const p = this.personenCollection2[this.selectedIdx];
      let text = p.text;
      if (text) {
        text =
          '<span style="font-weight:bold">' + p.content + "</span>, " + text;
      }
      return text;
    }
  }
};
</script>

<style lang="scss" >
.ksm-personen__page--wrapper {
  color: #000;
  background-color: #eee;
  @extend .ksm-flex;
}

.ksm-personen__page {
  @extend .ksm-flex-1;
  position: relative;
}

.ksm-personen__list-container {
  // @extend .ksm-accordion__body;
  overflow: auto;
  @extend .ksm-accordion__expand;
  padding: 10px;
  padding-bottom: 100px;
  background-color: rgba($color: #f8f2f2, $alpha: 0.4);
}

.ksm-personen__title {
  font-weight: bold;
  &.__active {
    color: $darkRed;
  }
}

.ksm-personen__has {
  margin: 0 5px;
  height: 22px;
  width: 22px;
  svg {
    * {
      fill: $blue1;
      stroke: #fff;
    }
    width: 100%;
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// Personen.vue?77d4293a